import { Tooltip } from '@material-ui/core';
import InputNumber from 'components/base/InputNumber';
import Icon from 'components/base/Icon';
import {
  LBButton,
  LBLabel,
  LBRadioGroup,
  LBRadioGroupItem
} from '@linearb/buzz';

const LimitToggler = ({
  limit,
  updateLimit,
  showAllSegments,
  toggleShowAllSegments,
  source
}) => {
  return (
    <LBRadioGroup
      value={showAllSegments.toString()}
      onValueChange={toggleShowAllSegments}
    >
      <div className='flex flex-row items-center gap-2'>
        <LBRadioGroupItem
          value='false'
          id={`false-${source}`}
          data-testid='show-up-to-radio'
          data-cy={`show-up-to-radio-${source}`}
        />
        <LBLabel htmlFor={`false-${source}`}>Show up to</LBLabel>
        <InputNumber
          value={limit}
          onChange={updateLimit}
          max={20}
          min={1}
          disabled={showAllSegments}
        />
        segments
      </div>
      <div className='flex flex-row items-center gap-2'>
        <LBRadioGroupItem
          value='true'
          id={`true-${source}`}
          data-testid='show-all-segments-radio'
          data-cy={`show-all-segments-radio-${source}`}
        />
        <LBLabel htmlFor={`true-${source}`}>Show all segments</LBLabel>
        <Tooltip title='limited to 50 segments max'>
          <LBButton variant='ghost' size='icon'>
            <Icon name='InfoOutlined' size='small' />
          </LBButton>
        </Tooltip>
      </div>
    </LBRadioGroup>
  );
};

export default LimitToggler;
